<script>
	import LegalDocument from '$lib/components/LegalDocument.svelte';
	import privacyMd from './privacy.md?raw';
</script>

<LegalDocument title="개인정보처리방침" content={privacyMd} />
